import Banner from "../CommonComponents/Banner";
import FeatureSection from "../Components/FeatureSection";
import ProductivitySection from "../Components/ProductivitySection";
import TeamSection from "../Components/TeamSection";
import TnsDriving from "../Components/TnsDriving";
import TnsOperation from "../Components/TnsOperation";
import TnsReady from "../Components/TnsReady";
import UnifiedAccessSection from "../Components/UnifiedAccessSection";

function WhyTnsSabre() {
  const operationsData = [
    {
      id: 1,
      image: "/assets/aboutsec1.png",

      title: "Best-in-Class Technology from ",
      highlight: "Sabre",
      paragraphs: [
        "Sabre's technology isn't a refresh of what came before — it's a rebuilt, with cloud-native architecture and AI built into the foundation from the ground up. Through Sabre Mosaic™, TNS gives your agencies access to unified booking, retailing, payments, servicing, and insight tools, backed by Sabre IQ and an embedded AI layer trained on Sabre's global travel data. For new and independent consultants, Sabre Mosaic™ Agency Workspace Lite is the fastest way to start earning: a free, point-and-click booking tool — no cryptic commands, no steep learning curve — covering flights, hotels, and ground transport across traditional, NDC, and low-cost carrier content. New consultants can go from being hired to earning commissions in days, not months, then step up to the full Agency Workspace as their expertise grows. For experienced teams managing complex itineraries, Sabre Red 360 and the full Agency Workspace remain the deeper, more configurable platform — giving your agencies a clear growth path on a single, trusted technology partner rather than a patchwork of tools. ",
      ],
    },
  ];

  const operationsData3 = [
    {
      id: 1,
      image: "/assets/why-tns-card2.png",
      bgPosition: "center",
      title: "Superior Customer Service from ",
      highlight: "TNS Global",
      paragraphs: [
        "Technology is only as good as the support behind it. As Sabre's exclusive partner across our 14 markets, TNS Global's business is built around local, responsive service — not a call center on another continent.",
      ],
      listHeading: "Every agency gets: ",
      list: [
        "24/7 Helpdesk — phone, email, and in-person support from a team based in your market.",
        "Dedicated Account Executives for premium clients.",
        "Training & Certification — online and in-person Sabre training, plus webinars, tutorials, and certification programs.",
        "Seamless Onboarding — guided setup to get your agency live on Sabre's technology fast.",
        "Real-Time Data & Analytics — booking and performance insights to help you optimize, not just report.",
        "Consulting — tailored growth strategies from a team that has run aviation and logistics operations at scale.",
      ],
    },
  ];
  return (
    <>
      <Banner
        backgroundImage="/assets/aboutus-banner.png"
        label="TNS & SABRE"
        heading={
          <>
            Two Strengths. One
          
          </>
        }
        heading2="Partnership"
        text={
          <> 
          World-class technology from Sabre. On-the-ground support from aviation professionals who know Africa.
          </>
        }
        buttons={[
          {
            text: "EXPLORE SOLUTIONS",
            variant: "primary",
            link: "/resources",
          },
        ]}
      />
      <TnsOperation
        bgImage="/assets/faq-left-pattern.png"
        operationsData={operationsData}
      />
      <TnsDriving
        bgImage="/assets/operation-bg.png"
        operationsData={operationsData3}
      />
      <ProductivitySection />
      <FeatureSection />
      <TeamSection />
      <UnifiedAccessSection />
      <TnsReady />

   
    </>
  );
}

export default WhyTnsSabre;
